import React from "react";
import { Link } from "react-router-dom";
import LogsDashboard from "./pages/LogsDashboard";

const Logs = () => {
    return (
        <>
            <div className="container container-xxl">
                <div className="pagetitle d-flex justify-content-between">
                    <h1><i className="bi bi-journal-text"></i> Scheduler Logs</h1>
                </div>
                <LogsDashboard />
            </div>
        </>
    );
};

export default Logs;